import { cn } from "@reactive-resume/utils";

import { BrandMark } from "@/client/components/brand-mark";
import { BRANDING } from "@/client/constants/branding";

type Props = {
  size?: number;
  className?: string;
  withText?: boolean;
};

export const Logo = ({ size = 32, className, withText = false }: Props) => {
  if (withText) {
    return (
      <div className={cn("inline-flex items-center gap-2.5", className)}>
        <BrandMark size={size} title={BRANDING.logo.alt} />
        <span
          className="font-sans font-semibold tracking-tight text-foreground"
          style={{ fontSize: `${Math.round(size * 0.5)}px`, letterSpacing: "-0.025em" }}
        >
          {BRANDING.name}
        </span>
      </div>
    );
  }

  return <BrandMark size={size} title={BRANDING.logo.alt} className={className} />;
};
